import React, { useState } from 'react';
import { HorizontalBarChart } from '../../../components/charts/horizontal-bar-chart';
import ReportTimePeriodSelector from '../../../components/report-time-period-selector/report-time-period-selector';
import { Box, Stack } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { motion, AnimatePresence } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { GET_TIMELINE_REPORT_ON_CATEGORY } from '../expense-manager.reducer';
import { createReportData } from '../utils';
import { ThreeCircles } from 'react-loader-spinner';
import Modal from '@mui/material/Modal';
import lodash from 'lodash';

const containerVariants = {
  hidden: {
    x: '-100vw',
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'spring',
      delay: 0.25,
    },
  },
  exit: {
    x: '+100vw',
    transition: { ease: 'easeInOut' },
  },
};

const incomeReportOptions = {
  indexAxis: 'y',
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
    title: {
      display: true,
      text: 'Income Report',
    },
    tooltip: {
      intersect: true,
      position: 'nearest',
    },
  },
  scales: {
    x: {
      ticks: {
        // Include a dollar sign in the ticks
        callback: function (value, index, ticks) {
          // console.log('value:', value, ', index:', index, ', ticks:', ticks);
          return '$' + value;
        },
      },
    },
    y: {
      ticks: {
        autoSkip: false,
        // Include a dollar sign in the ticks
        callback: function (value) {
          // console.log('value:', value, ', index:', index, ', ticks:', ticks);
          return this.getLabelForValue(value);
        },
      },
    },
  },
};

const expenseReportOptions = lodash.cloneDeep(incomeReportOptions);
lodash.set(expenseReportOptions, 'plugins.title.text', 'Expense Report');
lodash.set(expenseReportOptions, 'plugins.tooltip.intersect', false);

export default function TimelineOnCategory() {
  const [reportType, setReportType] = useState('grouped-by-category');
  const [showDrillDown, setShowDrillDown] = useState(false);
  const dispatch = useDispatch();
  const { currentReport, actionInProgress, categories } = useSelector((state) => state.expenseManager);
  console.log('categories:', categories);
  const incomeReportData = createReportData({
    inputData: currentReport.reportData.filter((item) => item.category_total >= 0),
  });
  const expenseReportData = createReportData({
    inputData: currentReport.reportData.filter((item) => item.category_total < 0),
  });
  console.log('actionInProgress:', actionInProgress);

  /* useEffect(() => {
    refreshData({ timePeriod: 'current-month' });
  }, [reportType]); */

  const refreshData = ({ timePeriod, category = '' }) => {
    console.log('refreshData timePeriod:', timePeriod);
    dispatch({
      type: GET_TIMELINE_REPORT_ON_CATEGORY,
      filters: { timePeriod, category: category || categories[0].category_name },
    });
  };

  const handleReportTypeChange = (evt) => {
    setReportType(evt.target.value);
  };

  const handleDrillDown = ({ category }) => {
    console.log('handleDrillDown category:', category);
    setShowDrillDown(true);
  };

  return (
    <>
      <h1> Timeline on Category</h1>
      <Stack flexDirection="row" justifyContent="flex-end" width="100%" mb="1rem">
        <Box>
          <FormControl
            sx={{
              minWidth: 250,
            }}
            size="small"
          >
            <InputLabel id="report-type-selector-label">Report type</InputLabel>
            <Select
              labelId="report-type-selector-label"
              id="report-type-selector"
              value={reportType}
              label="Report type"
              onChange={handleReportTypeChange}
            >
              <MenuItem value="">
                <em>Select a report type</em>
              </MenuItem>
              <MenuItem value={'grouped-by-category'}>By Category</MenuItem>
              <MenuItem value={'grouped-by-sub-category'}>By Sub-category</MenuItem>
              <MenuItem value={'third-type'}>Third type</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <ReportTimePeriodSelector
          defaultTimePeriod="current-month"
          refreshData={refreshData}
          excludeTimePeriods={['Current month']}
        />
      </Stack>
      {actionInProgress ? (
        <Box width="100%" height="300px" display="flex" flexDirection="row" justifyContent="center" alignItems="center">
          <ThreeCircles
            height="200"
            width="200"
            color="#4fa94d"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor=""
            innerCircleColor=""
            middleCircleColor=""
          />
        </Box>
      ) : (
        <AnimatePresence mode={'wait'}>
          <motion.div
            className="container"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            minheight="500px"
            height={currentReport.reportData.length > 0 ? `${currentReport.reportData.length * 15}px` : '500px'}
            width="100%"
          >
            {incomeReportData && incomeReportData.labels && incomeReportData.datasets ? (
              <Stack flexDirection="column" gap="4rem" marginBottom="2rem">
                <HorizontalBarChart
                  data={incomeReportData}
                  options={incomeReportOptions}
                  handleOnClick={handleDrillDown}
                />
                <HorizontalBarChart
                  data={expenseReportData}
                  options={expenseReportOptions}
                  handleOnClick={handleDrillDown}
                />
              </Stack>
            ) : (
              <h3>{'No data found for the selected period'}</h3>
            )}
          </motion.div>
        </AnimatePresence>
      )}
      <Modal
        open={showDrillDown}
        onClose={() => setShowDrillDown(false)}
        aria-labelledby="drill-down-modal"
        aria-describedby="drill-down-modal"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '80%',
            height: '80%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'background.paper',
            border: '2px solid #DDD',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2 id="drill-down-modal">Drill down</h2>
        </Box>
      </Modal>
    </>
  );
}
